// Existing stored values remain unchanged; legacy database validation messages
// are presented in English even when an older RPC still raises Arabic text.
export function englishError(message) {
  const value = String(message || "Unable to complete the request.");
  if (!/[\u0600-\u06ff]/.test(value)) return value;
  return "The database rejected this request. Check stock, quantities, and required fields, then try again.";
}
